/**
 * Converts Object to: key-val-- (repeating)
 *
 * @param obj
 * @returns {string}
 */
const stringifyObject = function (obj) {
  let str = ''

  if (Object.keys(obj).length === 0) return ''

  for (let k in obj) {
    if (!obj.hasOwnProperty(k)) continue
    let val = obj[k] || 'null'

    if (typeof val === 'string' && val.includes('.')) {
      val = val.replace(/\./g, '_dot_')
      val = encodeURI(val)
    }

    str = str.concat(k + '-' + val + '--')
  }

  return str.substring(0, str.length - 2)
}

export default stringifyObject



// WEBPACK FOOTER //
// ./src/functions/stringifyObject.js